var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"snackbar snackbar_show",class:{
    snackbar_hide: _vm.isHide,
  },on:{"click":function($event){return _vm.$emit('reopen')}}},[_c('div',{staticClass:"snackbar__title"},[_vm._v(" "+_vm._s(_vm.message)+" "),_c('span',[_vm._v(_vm._s(_vm.$t("forms.snackbarReopen")))])])])}
var staticRenderFns = []

export { render, staticRenderFns }